import type { ReactNode } from "react";

export default ({
  children,
  className = "",
  title,
  subtitle,
  action,
}: {
  children: ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
  action?: ReactNode;
}) => {
  return (
    <div className={`enterprise-card rounded-2xl border-slate-200 bg-white p-6 shadow-sm ${className}`}>
      {(title || action) && (
        <div className="mb-6 flex items-center justify-between">
          <div>
            {title && <h3 className="text-lg font-bold tracking-tight text-slate-900">{title}</h3>}
            {subtitle && <p className="mt-0.5 text-xs font-bold text-slate-400">{subtitle}</p>}
          </div>
          {action}
        </div>
      )}
      {children}
    </div>
  );
};
